import { makeStyles } from '@material-ui/core';
// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var styles = makeStyles(function (theme) {
    var _a;
    return ({
        combine: {
            order: 2,
        },
        scrollButtons: {
            width: '4.09vw',
            '&.Mui-disabled': {
                opacity: 0.4,
            },
        },
        indicator: {
            // To fix a specificity issue with MuiTabs
            '&&': {
                height: '3px',
                background: ((_a = theme === null || theme === void 0 ? void 0 : theme.configColors) === null || _a === void 0 ? void 0 : _a.secondaryColor) || theme.palette.secondary.main,
            },
        },
    });
});
